import { ActionType } from "./model";
import type {
  UpdateUserProfilePayload,
  VerifyUserPayload,
  LoginUserPayload,
  LoginShopifyUserPayload,
} from "./model";

import { ActionTypeOnly, ActionCallback, IValidationCallback } from "../model";
import { GoogleLoginPayload } from "./types";

export const loginUser = (
  payload: VerifyUserPayload,
  callback?: IValidationCallback
): ActionCallback<VerifyUserPayload> => ({
  type: ActionType.LOGIN_USER,
  payload,
  callback,
});

export const getOtpCode = (
  payload: LoginUserPayload,
  callback: IValidationCallback
): ActionCallback<LoginUserPayload> => ({
  type: ActionType.GET_OTP_CODE,
  payload,
  callback,
});

export const loginShopifyUser = (
  payload: LoginShopifyUserPayload,
  callback: IValidationCallback
): ActionCallback<LoginShopifyUserPayload> => ({
  type: ActionType.LOGIN_SHOPIFY_USER,
  payload,
  callback,
});

export const logoutUser = () => ({
  type: ActionType.LOGOUT_USER,
});

export const setShopifyUser = (
  payload: { shopify_user: string | null; },
  callback?: IValidationCallback
): ActionCallback<{
  shopify_user: string | null;
}> => ({
  type: ActionType.SET_SHOPIFY_USER,
  payload,
  callback,
});

export const accountLinkCheck = (
  payload: { email: string },
  callback: IValidationCallback
): ActionCallback<{ email: string }> => ({
  type: ActionType.ACCOUNT_LINK_CHECK,
  payload,
  callback,
});

export const linkAccounts = (
  payload: { email: string },
  callback: IValidationCallback
): ActionCallback<{ email: string }> => ({
  type: ActionType.LINK_ACCOUNTS,
  payload,
  callback,
});

export const accountLinkConfirm = (
  payload: VerifyUserPayload,
  callback: IValidationCallback
): ActionCallback<VerifyUserPayload> => ({
  type: ActionType.ACCOUNT_LINK_CONFIRM,
  payload,
  callback,
});

export const getProfile = (): ActionTypeOnly => ({
  type: ActionType.GET_PROFILE,
});

export const updateProfile = (
  payload: UpdateUserProfilePayload,
  callback?: IValidationCallback
): ActionCallback => ({
  type: ActionType.UPDATE_PROFILE,
  payload,
  callback,
});

export const checkAuthAction = (callback?: IValidationCallback) => ({
  type: ActionType.CHECK_AUTH,
  callback,
});

export const setScanHash = (
  payload: string | null,
  callback?: IValidationCallback
): ActionCallback => ({
  type: ActionType.SET_SCAN_HASH,
  payload,
  callback,
});

export const loginWithGoogle = (payload: GoogleLoginPayload) => ({
  type: ActionType.GOOGLE_LOGIN_REQUEST,
  payload,
})

export const googleLoginSuccess = (response: any) => ({
  type: ActionType.GOOGLE_LOGIN_SUCCESS,
  payload: response,
})

export const googleLoginFailure = (error: Error) => ({
  type: ActionType.GOOGLE_LOGIN_FAILURE,
  payload: error,
})
